import React from 'react';
import {Row, Col} from 'react-flexbox-grid/lib';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import {darkBlack} from 'material-ui/styles/colors';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';

import EventClassification from 'containers/eventClassification/EventClassification';
import NotAvailable from 'components/notAvailable/NotAvailable';
import styles from './styles/MainDataStyles';
import SpinnerLoaderWithText from 'components/loaders/SpinnerLoaderWithText';
import ButtonLoaderWithText from 'components/loaders/ButtonLoaderWithText';
import {convertMiPerHourToKmPerHour} from 'services/systemOfUnitsServices';
import moment from 'moment';

const MainData = ({translate, currentLanguage, icn, device, isMilesPerHour, account, isIcnLoading, rawOffset, dstOffset }) => {

    console.info("main data rendered");

    /*
        la velocità salvata nell'icn è sempre in miles per hour
    */
    var speedKmPH;
    if(!isMilesPerHour && icn)
    {
        /*
            l'unità di misura dell'utente è in km/h
        */
        speedKmPH = convertMiPerHourToKmPerHour(icn.speed);
    }

    var localDate;
    if(rawOffset !== null && dstOffset !== null && icn !== null)
    {
        var momentutc = moment.utc(icn.crashDate);
        localDate = momentutc.utcOffset((dstOffset + rawOffset) / 60);
    }

    return (
        <div>
            {
                isIcnLoading ? <SpinnerLoaderWithText /> :

                <Row style={styles.mainDataRow} >
                    <Col xs={12} sm={12} md={12} lg={6}  >
                        <Card initiallyExpanded={true}>
                            <CardHeader
                                title={translate('DetailsPage.vehicleDetailsTitle')}
                                actAsExpander={true}
                                showExpandableButton={true}
                            />
                            <CardText expandable={true} >
                            {
                                icn ?
                                <List>
                                    <ListItem
                                        innerDivStyle={styles.listItemView}
                                        primaryText={
                                            <p style={styles.listItemViewParagraph}  >
                                                <span style={{color: darkBlack}}>
                                                    {translate('GLOBAL.vinRegion')}:&nbsp;&nbsp;
                                                </span>
                                                {icn.vinRegion}
                                            </p>
                                        }

                                    />
                                    <Divider/>
                                    <ListItem
                                        innerDivStyle={styles.listItemView}
                                        primaryText={
                                            <p style={styles.listItemViewParagraph}  >
                                                <span style={{color: darkBlack}}>
                                                    {translate('GLOBAL.make')}:&nbsp;&nbsp;
                                                </span>
                                                {icn.make}
                                            </p>
                                        }

                                    />
                                    <Divider/>
                                    <ListItem
                                        innerDivStyle={styles.listItemView}
                                        primaryText={
                                            <p style={styles.listItemViewParagraph}  >
                                                <span style={{color: darkBlack}}>
                                                    {translate('GLOBAL.model')}:&nbsp;&nbsp;
                                                </span>
                                                {icn.model}
                                            </p>
                                        }

                                    />
                                    <Divider/>
                                    <ListItem
                                        innerDivStyle={styles.listItemView}
                                        primaryText={
                                            <p style={styles.listItemViewParagraph}  >
                                                <span style={{color: darkBlack}}>
                                                    {translate('GLOBAL.year')}:&nbsp;&nbsp;
                                                </span>
                                                {icn.year}
                                            </p>
                                        }

                                    />
                                    <Divider/>
                                    <ListItem
                                        innerDivStyle={styles.listItemView}
                                        primaryText={
                                            <p style={styles.listItemViewParagraph}  >
                                                <span style={{color: darkBlack}}>
                                                    {translate('GLOBAL.licenseNumber')}:&nbsp;&nbsp;
                                                </span>
                                                {icn.licenseNumber}
                                            </p>
                                        }

                                    />
                                    <Divider/>
                                    <ListItem
                                        innerDivStyle={styles.listItemView}
                                        primaryText={
                                            <p style={styles.listItemViewParagraph}  >
                                                <span style={{color: darkBlack}}>
                                                    {translate('GLOBAL.vin')}:&nbsp;&nbsp;
                                                </span>
                                                {icn.vin}
                                            </p>
                                        }

                                    />
                                    <Divider/>
                                    <ListItem
                                        innerDivStyle={styles.listItemView}
                                        primaryText={
                                            <p style={styles.listItemViewParagraph}  >
                                                <span style={{color: darkBlack}}>
                                                    {translate('GLOBAL.deviceESN')}:&nbsp;&nbsp;
                                                </span>
                                                {
                                                    device ? device.esn : null
                                                }
                                            </p>
                                        }

                                    />
                                    <Divider/>
                                    <ListItem
                                        innerDivStyle={styles.listItemView}
                                        primaryText={
                                            <p style={styles.listItemViewParagraph}  >
                                                <span style={{color: darkBlack}}>
                                                    {translate('GLOBAL.deviceIMEI')}:&nbsp;&nbsp;
                                                </span>
                                                {
                                                    device ? device.imei : null
                                                }
                                            </p>
                                        }

                                    />
                                </List>
                                : <NotAvailable />
                            }

                            </CardText>
                        </Card>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6}  >

                        <Card  initiallyExpanded={true}>
                            <CardHeader
                                title={translate('DetailsPage.crashEventDetailsTitle')}
                                actAsExpander={true}
                                showExpandableButton={true}
                            />
                            <CardText expandable={true} >
                                {
                                    icn ?
                                    <List>

                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.caseId')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icn.id}
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.crashSeverity')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icn.severityCode}
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <EventClassification />
                                            }
                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.account')}:&nbsp;&nbsp;
                                                    </span>
                                                    {
                                                        account ? account.name : <ButtonLoaderWithText />
                                                    }
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={

                                                isMilesPerHour ?
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.preCrashSpeed')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icn.speed}&nbsp;{translate('GLOBAL.miph')}
                                                </p>
                                                :
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.preCrashSpeed')}:&nbsp;&nbsp;
                                                    </span>
                                                    {speedKmPH}&nbsp;{translate('GLOBAL.kmph')}
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.crashDate')}:&nbsp;&nbsp;
                                                    </span>
                                                    {moment.utc(icn.crashDate).locale(currentLanguage).format("L")}
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.crashTime')}:&nbsp;&nbsp;
                                                    </span>
                                                    {moment.utc(icn.crashDate).locale(currentLanguage).format("LT")}
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.localTime')}&nbsp;{translate('GLOBAL.crashDate')}:&nbsp;&nbsp;
                                                    </span>
                                                    {
                                                        localDate ? localDate.locale(currentLanguage).format("L") : <ButtonLoaderWithText />
                                                    }
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                    {translate('GLOBAL.localTime')}&nbsp;{translate('GLOBAL.crashTime')}:&nbsp;&nbsp;
                                                    </span>
                                                    {
                                                        localDate ? localDate.locale(currentLanguage).format("LT") : <ButtonLoaderWithText />
                                                    }
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.crashLatitude')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icn.latitude}
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.crashLongitude')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icn.longitude}
                                                </p>
                                            }

                                        />

                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.address1')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icn.street1}
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.address2')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icn.street2}
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.zip')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icn.zip}
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.city')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icn.city}
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.stateProvince')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icn.stateProvince}
                                                </p>
                                            }

                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.country')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icn.country}
                                                </p>
                                            }

                                        />

                                        <Divider/>


                                    </List>
                                    : <NotAvailable />
                                }


                            </CardText>
                        </Card>
                    </Col>
                </Row>
            }
        </div>
    );

}

function mapStateToProps(state, ownProps){

    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        icn: state.icnSearch.item,
        isIcnLoading: state.icnSearch.isSearching,
        device: state.deviceSearch.item,
        isDeviceLoading: state.deviceSearch.isSearching,
        isMilesPerHour: state.systemUnitsSearch.item ? state.systemUnitsSearch.item.isMilesPerHour : false,
        speedUnitOfMeasure: state.systemUnitsSearch.item ? state.systemUnitsSearch.item.speedUnitOfMeasure : null,
        dstOffset: state.googleSearch.dstOffset,
        rawOffset: state.googleSearch.rawOffset,
        account: state.accountSearch.item
    }
}

export default connect(mapStateToProps, null)(MainData);


// WEBPACK FOOTER //
// ./src/components/detailsPage/MainData.js